<template>
  <nav>
    <router-link to="/">Home</router-link> |
    <router-link to="/about">About</router-link>
  </nav>
    <h1>Browse & Fly App</h1>
  <router-view/>
</template>
